'use client';

import { cn } from '@repo/utils/cn';
import React, { useEffect, useState } from 'react';
import { useTenant } from '@/providers/TenantProvider';

type TenantLogoProps = {
  className?: string;
};

const TenantLogo = ({ className }: TenantLogoProps) => {
  const { tenantMachineName } = useTenant(); // e.g. "vatan"
  const [Logo, setLogo] = useState<React.FC<any> | null>(null);

  useEffect(() => {
    if (!tenantMachineName) return;

    (async () => {
      try {
        const { Logo } = await import(`@/assets/tenants/${tenantMachineName}/logo`);
        setLogo(() => Logo);
      } catch (err) {
        console.error('Failed to load tenant logo:', err);
      }
    })();
  }, [tenantMachineName]);

  if (!Logo) return null;

  return <Logo className={cn('max-w-[110px] flex-shrink-0 sm:max-w-[130px]', className)} />;
};

export default TenantLogo;
